"use client";
import Link from "next/link";
import { useState } from "react";

import { HEADER_LINKS } from "@/constants/header";
import { PATH } from "@/constants/path";
import SList from "@public/image/icon/list.svg";
import SLogo from "@public/image/icon/logo.svg";
import SX from "@public/image/icon/x.svg";

import Button from "../Button";
import HeaderItem from "./atoms/HeaderItem";

function HeaderMobile() {
  const [isOpen, setOpen] = useState<boolean>(false);

  const toggleNavBar = () => {
    setOpen((prev) => !prev);
  };

  const closeNavBar = () => {
    setOpen(false);
  };

  return (
    <div className="fixed left-0 top-0 z-50 flex h-16 w-screen flex-col items-center justify-center bg-white px-4 header:hidden">
      <div className="flex w-full items-center justify-between">
        {/* 로고 */}
        <Link href="/" onClick={closeNavBar}>
          <SLogo className="w-32" />
        </Link>

        <button onClick={toggleNavBar}>
          {isOpen ? <SX className="size-8" /> : <SList className="size-8" />}
        </button>
      </div>

      {isOpen && (
        <div className="absolute left-0 top-16 z-50 flex w-full flex-col items-center gap-4 bg-white pb-7 backdrop-blur-sm">
          {/* 링크 목록 */}
          <div className={`flex w-full flex-col items-center gap-1`}>
            {HEADER_LINKS.map(({ label, href }) => (
              <HeaderItem
                key={href}
                href={href}
                className="w-full"
                onClick={closeNavBar}
              >
                {label}
              </HeaderItem>
            ))}
          </div>
          {/* 버튼 목록 */}
          <div className="flex gap-2">
            <a
              href="https://jd-creator.searchright.net?utm_source=homepage&utm_medium=organic&utm_campaign=header-button&utm_content=jd"
              target="_blank"
              rel="noopener noreferrer"
              className="relative rounded-md border border-primary bg-blue-50 px-4 py-2 text-14 font-normal text-primary"
              onClick={closeNavBar}
            >
              JD Creator
              <span className="absolute -right-2 -top-2 rounded bg-primary px-1.5 py-0.5 text-[10px] font-bold leading-none text-white">
                BETA
              </span>
            </a>
            {/*<Button*/}
            {/*  color="white"*/}
            {/*  size="sm"*/}
            {/*  border="gray"*/}
            {/*  href={PATH.DEMO_CLIENT}*/}
            {/*>*/}
            {/*  서비스 체험하기*/}
            {/*</Button>*/}
            <Button
              color="primary"
              size="sm"
              href={PATH.REQUEST}
              onClick={closeNavBar}
            >
              문의하기
            </Button>
          </div>
        </div>
      )}
    </div>
  );
}

export default HeaderMobile;
